<h2 class="user-title">Chat de apoio</h2>
<!-- <div class="no-results-wrapper">
    Não há mensagens novas
</div> -->
<app-chat-support></app-chat-support>